import {
    AdverseEventsSection,
    EntityCommandCreateResponse,
    RevisionedCommandResponse,
    StudyEntityType,
    toAdverseEventsSection,
} from '@faro/study-designer-model';
import axios from 'axios';
import { createStudyEntityHookFactory } from '../createStudyEntityHookFactory';
import { StudyPathParameter } from '../parameter';

const factory = createStudyEntityHookFactory<AdverseEventsSection>(StudyEntityType.AdverseEventsSection);

export const useAdverseEventsSections = factory.list(
    (
        { studyId, ...query }: StudyPathParameter & { revision?: number },
        signal?: AbortSignal
    ): Promise<AdverseEventsSection[]> => {
        return axios
            .get(`/api/study-designer/studies/${studyId}/adverse-events-sections`, {
                signal,
                params: query,
            })
            .then(response => (response.data ?? []).map(toAdverseEventsSection));
    }
);

export const useAdverseEventsSection = factory.get(
    (
        { studyId, id, ...query }: StudyPathParameter & { id: string; revision?: number },
        signal?: AbortSignal
    ): Promise<AdverseEventsSection> => {
        return axios
            .get(`/api/study-designer/studies/${studyId}/adverse-events-sections/${id}`, {
                signal,
                params: query,
            })
            .then(response => toAdverseEventsSection(response.data));
    }
);

export const useAdverseEventsSectionInsert = factory.mutate(
    (entity: Partial<AdverseEventsSection>): Promise<RevisionedCommandResponse<EntityCommandCreateResponse>> => {
        const { studyId } = entity;
        return axios
            .post(`/api/study-designer/studies/${studyId}/adverse-events-sections`, {})
            .then(response => response.data);
    }
);
